
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
	faHandPointUp,
	faHandPointLeft,
} from '@fortawesome/free-solid-svg-icons';

library.add(faHandPointUp, faHandPointLeft);

@Component
export default class HomePage extends Vue {
	windowWidth = window.innerWidth;

	created() {
		this.$root.$data.showCourses = true;
	}

	mounted() {
		window.addEventListener('resize', () => {
			this.windowWidth = window.innerWidth;
		});
	}

	get mobile() {
		return this.windowWidth <= 768;
	}
}
